import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
import {Lang} from './lang'
import axios from './common/axios'
import config from './config'
import {LoadingBar, Message, Notice, Progress } from 'iview'
import VueClipboard from 'vue-clipboard2'
import 'iview/dist/styles/iview.css'
import './assets/css/main.less'
import VueHighlightJS from 'vue-highlightjs'
import 'highlight.js/styles/atom-one-light.css'
import CodeEditor from 'bin-code-editor';
import 'bin-code-editor/lib/styles/index.css';
Vue.config.productionTip = false
Vue.use(VueI18n)
Vue.use(VueClipboard)
Vue.use(VueHighlightJS)
Vue.use(CodeEditor);
Vue.component('i-progress', Progress)
LoadingBar.config({
  color: '#50A0FF',
  failedColor: '#F09D4E',
});
Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Message = Message
Vue.prototype.$Notice = Notice
Vue.prototype.$axios = axios
Vue.prototype.$config = config

const i18n = new VueI18n({
  locale: localStorage.Lang ||'en',
  messages:{
    ...Lang
  }
})

router.beforeEach((to, from, next) => {
  LoadingBar.start();
  next();
});

router.afterEach(route => {
  LoadingBar.finish();
});

Vue.mixin({
  methods: {
    getTradeType(type) {
      return type == 'Payment'
              ? this.$t('payment')
              : type == 'OfferCreate'
              ? this.$t('offerCreate')
              : type == 'OfferCancel'
              ? this.$t('offerCancel')
              : type == 'AccountSet'
              ? this.$t('accountSet')
              : type == 'TrustSet'
              ? this.$t('trustSet')
              : type == 'MultiPayment'
              ? this.$t('multiPayment')
              : type == 'ContractUpload'
              ? this.$t('contractUpload')
              : type == 'ContractDeploy'
              ? this.$t('contractDeploy')
              : type == 'ContractCall'
              ? this.$t('contractCall')
              : type == 'SignerListSet'
              ? this.$t('signerListSet')
              : this.$t('other')
    },
    getTradeTypeAccount(type,address,account,destination) {
      return type == 'Payment'
              ? 
              (address == account ? this.$t('wallet.outgoing') : 
              (address != account && address == destination) ? this.$t('wallet.incoming') : this.$t('payment')) 
              : this.getTradeType(type)
    }
  }
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
